var App = App || {};

App.FeaturedCaseStudies = (function ($) {
    "use strict";

    function Init(selector) {
        if (selector.length) {
            selector.each(function () {
                var $this = $(this),
                    carousel = $this.find(".splide"),
                    progress = $this.find(".splide__progress-bar");

                if (carousel.length) {
                    Carousel(carousel, progress);
                }
            });
        }
    }

    function Carousel(carousel, progress) {
        const splide = new Splide(carousel[0], {
            breakpoints: {
                576: {
                    perPage: 2
                },
                992: {
                    perPage: 3
                }
            },
            gap: "1.5rem",
            mediaQuery: "min",
            pagination: false,
            perPage: 1
        });

        // Apply proper role attributes for list items
        // https://github.com/Splidejs/splide/issues/825#issuecomment-2365324992
        splide.on("mounted", function () {
            let $slides = carousel.find(".splide__slide");
            let $slideList = carousel.find(".splide__list");

            $slides
                .removeAttr("role")
                .attr("role", "listitem");

            if ($slideList.length) {
                $slideList
                    .removeAttr("role")
                    .attr("role", "list");
            }
        });

        splide.on("mounted resize", function () {
            const totalSlides = carousel.find(".splide__slide").length;
            const perPage = splide.options.perPage;

            const arrows = carousel.find(".splide__arrow");
            const progressBar = carousel.find(".splide__progress-bar");

            const shouldHideControls = totalSlides <= perPage;

            arrows.css("display", shouldHideControls ? "none" : "");
            progressBar.css("display", shouldHideControls ? "none" : "");
        });

        splide.on("mounted move resize", function (e) {
            Progress(splide, progress);
        });

        splide.mount();
    }

    function Progress(splide, progress) {
        var end = splide.Components.Controller.getEnd() + 1,
            rate = Math.min((splide.index + 1) / end, 1),
            width = String(100 * rate) + "%";

        $(progress).css("width", width);
    }

    return {
        Init: Init
    };
})(jQuery);